var storage = require('storage')
var CellView = require('../table/cell-view')
var HeaderCellView = require('../table/header-cell-view')

var Column = Em.Object.extend({
    // Injected in list-controller
    controller: null,

    visible: function(key, visible) {
        if (!this.get('hideable')) {
            return true
        }
        var controller = this.get('controller')
        if (!controller) {
            return true
        }
        var storageKey = 'columnVisibility:' + controller.get('storageKey') + '_' + this.get('name')
        if (arguments.length > 1) {
            storage(storageKey, visible)
            return visible
        } else {
            var storageVisible = storage(storageKey)
            if (storageVisible) {
                return storageVisible === 'true'
            }
            return this.get('defaultVisible')
        }
    }.property('controller', 'hideable', 'defaultVisible'),

    defaultVisible: true,

    hideable: true,

    align: 'left',

    width: null,
    flex: null,

    multiline: false,
    sortable: false,

    cellViewClass: CellView,
    headerCellViewClass: HeaderCellView,

    init: function() {
        this._super()
        Ember.assert('No width or flex set for column `' + this.get('name') + '`.', this.get('width') || this.get('flex'))
    },

    layoutClass: function() {
        return Column.getLayout(this.getProperties('flex', 'width')).layoutClass
    }.property('flex'),

    style: function() {
        return Column.getLayout(this.getProperties('flex', 'width')).style
    }.property('width', 'flex'),

    format: function(value) {
        return value
    }
})

Column.reopenClass({
    getLayout: function(props) {
        var style = []
        if (props.flex) {
            style.push('--column-flex:' + props.flex)
        }
        if (props.width) {
            style.push('--column-width:' + props.width + 'px')
        }
        return {
            layoutClass: props.flex ? 'table-cell-flex' : 'table-cell-fixed',
            style: style.join(';') + ';'
        }
    }
})

module.exports = Column
